module.exports = __webpack_public_path__ + "static/media/LectureSeriesPoster.f182c220.png";